import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDataLayout } from "../../data/redux/themeSettingSlice";
import ImageWithBasePath from "../imageWithBasePath";
import {
  setMobileSidebar,
  toggleMiniSidebar,
} from "../../data/redux/sidebarSlice";
import { all_routes } from "../../../feature-module/router/all_routes";
// import { HorizontalSidebarData } from '../../data/json/horizontalSidebar'
import useAuth from "../../../feature-module/Services/hook/useAuth";
import { jwtDecode } from "jwt-decode";
import Dropdown from 'react-bootstrap/Dropdown';

const Header = () => {
  const { signOut } = useAuth();
  const routes = all_routes;
  const dispatch = useDispatch();
  const dataLayout = useSelector((state) => state.themeSetting.dataLayout);
  const Location = useLocation();

  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");

  const token = localStorage.getItem("LoginToken");
  const decodedToken = token ? jwtDecode(token) : null;

  const toggleSidebar = (title) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const mobileSidebar = useSelector(
    (state) => state.sidebarSlice.mobileSidebar
  );

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };

  const handleToggleMiniSidebar = () => {
    if (dataLayout === "mini_layout") {
      dispatch(setDataLayout("default_layout"));
      localStorage.setItem("dataLayout", "default_layout");
    } else {
      dispatch(toggleMiniSidebar());
    }
  };

  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => { });
        setIsFullscreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => { });
        }
        setIsFullscreen(false);
      }
    }
  };


  return (
    <>
      {/* Header */}
      <div className="header">
        <div
          className="main-header"
          // style={{
          //   background: "linear-gradient(to right,  #3B4371, #F3904F)",
          //   color: "white",
          //   padding: "10px 20px",
          //   alignItems: "center",
          // }}
          >
          <div className="header-left">
            <Link className="logo">
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/sai_logo/SAI_logo_Png_1.png`}
                style={{ width: 60, height: "auto", color: "white" }}
              />
            </Link>
          </div>

          <Link
            id="mobile_btn"
            onClick={toggleMobileSidebar}
            className="mobile_btn"
            to="#sidebar"
          >
            <span className="bar-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </Link>

          <div className="user-menu d-none d-md-inline">
            <div className="d-flex flex-column">
              <div className="align-self-end">
                <div className=" d-flex align-items-center">
                   {/* <div className="me-2">
                    {decodedToken?.Employee_Name} ({(decodedToken?.Role_Identifiers)})
                  </div>               */}
                  <Dropdown>
                    <Dropdown.Toggle variant="transparent" >
                      <i className="fas fa-2x fa-user me-2" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {/* <Dropdown.Item >
                        <p className="fs-12 fw-medium mb-0">
                          {decodedToken?.Employee_Name}
                        </p>
                      </Dropdown.Item> */}
                      <Dropdown.Item onClick={signOut}>
                        <i className="ti ti-login me-2"></i>
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                </div>
              </div>
            </div>
          </div>

          <div className="dropdown mobile-user-menu d-block d-md-none">
            <Dropdown>
              <Dropdown.Toggle variant="transparent" >
                <i className="fas fa-user me-2"></i>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item >
                  <p className="fs-12 fw-medium mb-0">
                    {decodedToken?.Employee_Name}
                  </p>
                </Dropdown.Item>
                <Dropdown.Item onClick={signOut}>
                  <i className="ti ti-login me-2"></i>
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

          </div>


        </div>
      </div>
      {/* /Header */}
    </>
  );
};

export default Header;
